import { GlobalOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { AvatarDropdown as CoreAvatarDropdown, useLocale } from '@zhiyue/core';
import { BizAppConfig } from 'config/application.manifest';
import React from 'react';

const AvatarDropdown: React.FC = () => {
  const { setLocale } = useLocale();
  return (
    <CoreAvatarDropdown
      appId={BizAppConfig.appSsoClientId}
      mergeDefaultItems
      items={[
        {
          key: 'help',
          icon: <QuestionCircleOutlined />,
          label: '帮助文档',
          href: 'https://docs.shanhuyun.cn/',
          target: '_blank',
        },
        { type: 'divider' },
        {
          key: 'language-zh-CN',
          icon: <GlobalOutlined />,
          label: '简体中文',
        },
        { key: 'language-en-US', label: 'English' },
      ]}
      onAction={(key) => {
        if (key.startsWith('language-'))
          setLocale(key.slice('language-'.length));
      }}
    />
  );
};

export default AvatarDropdown;
